import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ecp-note-form',
  templateUrl: './note-form.component.html',
  styleUrls: ['./note-form.component.scss'],
  standalone: false,
})
export class NoteFormComponent {
  note: any;
  constructor(public dialogRef: MatDialogRef<any>) {}

  addNote() {
    this.dialogRef.close(this.note);
  }
}
